import { render } from "./rechargeUsdtList.vue?vue&type=template&id=8b8050e0&scoped=true"
import script from "./rechargeUsdtList.vue?vue&type=script&lang=js"
export * from "./rechargeUsdtList.vue?vue&type=script&lang=js"

import "./rechargeUsdtList.vue?vue&type=style&index=0&id=8b8050e0&scoped=true&lang=css"
import "./rechargeUsdtList.vue?vue&type=style&index=1&id=8b8050e0&lang=css"

import exportComponent from "/home/runner/work/user-ui/user-ui/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b8050e0"]])

export default __exports__